import { container } from '../../../DataDomain';
import { IBundleAndSaveParams, IBundleAndSaveResponse } from '../../../entity';
import { ISlpRepository } from '../../repositories/interfaces/iSlpRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IBundleAndSaveUseCase {
    execute(payload: IBundleAndSaveParams): Promise<IBundleAndSaveResponse>;
}

export class BundleAndSaveUseCase implements IBundleAndSaveUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get slpRepo(): ISlpRepository {
        return container.resolve<ISlpRepository>(DI.REPOSITORIES.ISlpRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(payload: IBundleAndSaveParams): Promise<IBundleAndSaveResponse> {
        return await this.slpRepo.bundleAndSave(payload);
    }
}
